import React, { useState, useMemo } from 'react'
import { Table, Header, Icon } from 'semantic-ui-react'
import request from 'services/http'
import { tap } from 'rxjs/operators'
import { useSubscription } from 'utils'
import * as luxon from 'luxon'
import { dateIdToFormat } from '@rededompedro/utils'

export default function DrenagemHome() {

    const [drainages, setDrainages] = useState([])

    const drainages$ = useMemo(() => request({ method: 'GET', url: '/combustivel/drenagem/periodo' }).pipe(
        tap(({ response }) => setDrainages(response.drainages))
    ), [])

    useSubscription(drainages$)

    function getStatus(logId) {
        switch (logId) {
            case 1:
                return <span><Icon name='file' />Formulário Impresso</span>

            case 2:
                return <span><Icon name='rocket' />Lançamento Inciado</span>

            case 3:
                return <span style={{ color: 'green' }}><Icon name='check' />Concluído</span>
            
            default:
                return <span>Desconhecido</span>
        }
    }

    return (
        <>
            <Header size='medium' as='h2'>
                <Icon name='rocket' />
                <Header.Content>Drenagens
                    <Header.Subheader style={{ fontSize: 15 }}>Ultimas drenagens</Header.Subheader>
                </Header.Content>
            </Header>
            <Table celled style={{ fontSize: 16, marginTop: 40 }}>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell>ID</Table.HeaderCell>
                        <Table.HeaderCell>Impressão</Table.HeaderCell>
                        <Table.HeaderCell>Início</Table.HeaderCell>
                        <Table.HeaderCell>Fim</Table.HeaderCell>
                        <Table.HeaderCell>Status</Table.HeaderCell>
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    {drainages.map((d, i) => (
                        <Table.Row key={i}>
                            <Table.Cell>{d.id}</Table.Cell>
                            <Table.Cell>{luxon.DateTime.fromSQL(d.created_at).toFormat('ccc dd/MM/yyyy HH:mm', { locale: 'pt-BR' })}</Table.Cell>
                            <Table.Cell>{d.ini ? dateIdToFormat(d.ini, 'HH:mm') : '--'}</Table.Cell>
                            <Table.Cell>{d.fim ? dateIdToFormat(d.fim, 'HH:mm') : '--'}</Table.Cell>
                            <Table.Cell>{getStatus(d.last_log_id)}</Table.Cell>
                        </Table.Row>
                    ))}
                </Table.Body>
            </Table>
        </>
    )
}
